import React from 'react';
import Model from '../../components/Model';

export default function InstantText() {
  return (
    <Model
      title={'Instant Text Resize'}
      src={'/video/mobile/instant-text-resize.mp4'}
      para1={
        'The ability to instantly resize text from the log in page allows the user select a preferred text viewing size from the get-go.'
      }
    />
  );
}
